import React from 'react'
import { Button, Typography } from '@mui/material'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { useTranslation } from 'react-i18next'
import type { Location } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'

interface BackButtonProps {
  location: Location
}

export const BackButton: React.VFC<BackButtonProps> = ({ location }): JSX.Element => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <Button
      color="primary"
      variant="outlined"
      onClick={() => {
        // 前のページのURLを作る
        // @ts-ignore
        const prevState = (location.state === undefined || location.state === null) ? '' : location.state.prevLocationState
        const uri = prevState === '' ? -1 : `${prevState.pathname}${prevState.search}`
        // @ts-ignore
        navigate(uri, {
          replace: true,
          state: { ...prevState.state },
        })
      }}
      sx={{
        bgcolor:'#FFFFFF',
        padding: '8px 22px 8px 20px',
        width: '110px',
        height: '42px',
        marginBottom: '20px'
      }}

    >
      <ArrowBackIcon sx={{ color: '#3F51B5', width: '24px', height: '24px' }} />
      <Typography
        sx={{
          marginLeft: '12px',
          fontStyle: 'normal',
          fontSize: 15,
          lineHeight: '26px',
        }}
      >
        {t('common.back')}
      </Typography>
    </Button>
  )
}
